import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Checkbox from "components/forms/inputs/checkbox";
import TextareaInput from "components/forms/inputs/textarea";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faSave } from "components/icon-library";
import { showError, showSuccess } from "lib/notification";
import { List } from "models/list";
import { ListObligation } from "models/list-obligation";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { adminDoPatchList } from "services/admin/list";
import { adminDoPatchListObligation } from "services/admin/list-obligation";
import { fetchAdminList } from "stores/actions/list";
import { fetchListTemplate } from "stores/actions/list-template";
import * as yup from "yup";

interface ObligationFormProps {
  list: List;
  obligation: ListObligation;
}

const ObligationForm: FunctionComponent<ObligationFormProps> = ({
  list,
  obligation,
}) => {
  // build validation schema based on fields
  const schema = yup.object({
    obligation: yup.bool(),
    text: yup.object().validateLocaleString(),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      obligation: list.obligation,
      text: obligation.text,
    },
  });

  const handleSubmit = async (values: any) => {
    const { obligation, text } = values;
    try {
      // send to server
      await adminDoPatchList(list, { obligation });
      await adminDoPatchListObligation(list, text);

      // update
      if (list.template) {
        fetchListTemplate(list.uuid);
      } else {
        fetchAdminList(list.uuid);
      }

      // notify
      showSuccess("Velvoitteiden tallentaminen onnistui.");
    } catch (err) {
      showError("Velvoitteiden tallentaminen epäonnistui.");
    }
  };

  const buttons: FormButtonInterface[] = [
    {
      ...SubmitButton,
      text: "Tallenna velvoitteet",
      postIcon: faSave,
      align: "left",
    },
  ];

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            <Checkbox
              name="obligation"
              label="Näytä ilmoitusvelvollisille erilliset velvoitteet ja pyydä kuittaus niiden lukemisesta."
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextareaInput
              name="text"
              translations
              label="Velvoitteet teksti"
              height={40}
            />
          </Col>
        </Row>
      </Grid>
      <FormButtons buttons={buttons} />
    </Form>
  );
};

export default ObligationForm;
